<template>
    <div id="app" v-if="isFinished">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view></router-view>
    </div>
</template>

<script>
import { store, event } from "@ice/stark-data";
import { checkLogin, getQuery, jumpLogin, clearCookie } from "@/utils/commons";

export default {
    name: "app",
    data() {
        return {
            isFinished: false,
        };
    },
    async created() {
        const ticket = getQuery("ticket");

        // 未登录
        if (!checkLogin()) {
            // 有 ticket 则进行解析
            if (ticket) {
                this.parseTicket(ticket);
            } else {
                this.isFinished = true;
            }
        } else {
            await this.getUserInfo();
            this.isFinished = true;
        }
    },
    methods: {
        async parseTicket(ticket) {
            try {
                const { data: res } = await this.$http.get("/api/basic/parseTicket", {
                    params: {
                        ticket,
                    },
                });
                if (res.code === 0) {
                    window.location.reload();
                } else {
                    // 解析失败，重新登录
                    jumpLogin(window.location.href);
                }
            } catch (err) {
                console.log(err);
                // 解析失败，重新登录
                jumpLogin(window.location.href);
            }
        },
        // 查询用户信息
        async getUserInfo() {
            try {
                const { data: res } = await this.$http.get("/api/basic/getUserInfo");
                if (res.code === 0) {
                    store.set("userInfo", res.data);
                    event.emit("refreshStatus", res.data); // 触发更新操作
                } else {
                    clearCookie("GCLOUD_ID");
                    clearCookie("GCLOUD_SESSIONKEY");
                }
            } catch (err) {
                clearCookie("GCLOUD_ID");
                clearCookie("GCLOUD_SESSIONKEY");
            }
        },
    },
};
</script>

<style></style>
